module.exports = __webpack_public_path__ + "img/album01_02.71f4c2bc.jpg";